import React, { FC } from 'react';
import { Skeleton } from '@mui/material';
import { LoadingSkeletonProps } from './types';

const LoadingSkeleton: FC<LoadingSkeletonProps> = ({
  width = '100%',
  height = '100%',
}) => {
  return (
    <Skeleton
      sx={{
        width,
        height,
        justifySelf: 'center',
        transform: 'none',
        // borderRadius: '10px',
      }}
    />
  );
};

export default LoadingSkeleton;
